import { render, staticRenderFns } from "./cardBottom.vue?vue&type=template&id=f59de2fe&scoped=true"
import script from "./cardBottom.vue?vue&type=script&lang=js"
export * from "./cardBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59de2fe",
  null
  
)

export default component.exports